import { render } from "./ProjectNewProjectDialog.vue?vue&type=template&id=385bcf56"
import script from "./ProjectNewProjectDialog.vue?vue&type=script&lang=js"
export * from "./ProjectNewProjectDialog.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__